import React, { useState, useEffect, useContext, memo } from 'react';
import { AuthContext } from '../context/authContext';
import { useFormContext } from '../context/FormContext';
import { Input, Label, Button, Select_simple } from "./ui";
import options from '../datos/options.json'

//const TipoProyectoSubform = ({ onFormChange, onDataChangeSub, arrayTipoSubtipoProyecto}) => {
const TipoProyectoSubform = () => {
    // Obtener el contexto
    const { formA, updateField, loadField, markSectionDirty } = useFormContext();

    const {user} = useContext(AuthContext)

    //const [mensajeNieto, setMensajeNieto] = useState("Mensaje inicial del Nieto (useEffect)");

    //ANTES
    //const [rows, setRows] = useState([{ tipo: '', subtipo: '', cantidad: '', unidad: '' }]); //referencia: ''
    // Estado local para las filas
    const [rows, setRows] = useState(() => {
        // Si formA?.tipoSubtipoProyecto existe y es un array, úsalo
        // De lo contrario, usa el array por defecto
        const initialData = formA?.tipoSubtipoProyecto;
        console.log("GATO initialData", initialData)
        return Array.isArray(initialData) && initialData.length > 0 
          ? initialData 
          : [{ tipo: '', subtipo: '', cantidad: '', unidad: '' }];
      });
    console.log("GATO rows", rows)
    ////formA?.datosGenerales?.tipoSubtipoProyecto || [ //NO DENTRO DE datosGenerales

    //UseEffect***
    // Sincronizar con el contexto cuando cambia
    useEffect(() => {
        //if (formA?.datosGenerales?.tipoSubtipoProyecto) {
        if (Array.isArray(formA?.tipoSubtipoProyecto)) {
            setRows(formA.tipoSubtipoProyecto);
        } else {
            // Reset: el form fue reseteado (formA = {}) o aún no hay datos → limpiar filas
            setRows([{ tipo: '', subtipo: '', cantidad: '', unidad: '' }]);
        }
    }, [formA?.tipoSubtipoProyecto]);

    // Nota: loadField se llama directamente en handlers (addRow, removeRow, handleChange)
    // para evitar loop infinito entre UseEffect 1 (contexto→rows) y UseEffect 2 (rows→contexto)

    // ****Agregar fila****
    //ANTES
    /*
    const handleAddRow = () => {
        setRows([...rows, { tipo: '', subtipo: '', cantidad: '', unidad: '' }]); //, referencia: ''
    };
    */
    const addRow = () => {
        markSectionDirty('formA');
        setRows(prevRows => {
            const newRow = { tipo: '', subtipo: '', cantidad: '', unidad: '' };
            const updated = [...(Array.isArray(prevRows) ? prevRows : []), newRow];
            loadField('formA', 'tipoSubtipoProyecto', null, updated);
            return updated;
        });
    };

    // ****Eliminar fila****
    //ANTES
    /*
    const handleRemoveRow = (index) => {
        const updatedRows = rows.filter((_, i) => i !== index);
        setRows(updatedRows);       
    };
    */
    const removeRow = (index) => {
        markSectionDirty('formA');
        setRows(prevRows => {
            if (!Array.isArray(prevRows) || prevRows.length <= 1) {
                const single = [{ tipo: '', subtipo: '', cantidad: '', unidad: '' }];
                loadField('formA', 'tipoSubtipoProyecto', null, single);
                return single;
            }
            const updated = prevRows.filter((_, i) => i !== index);
            loadField('formA', 'tipoSubtipoProyecto', null, updated);
            return updated;
        });
      };

    // Manejar cambios en los campos**
    //ANTES
    
    const handleChange = (index, field, value) => {
        markSectionDirty('formA');
        const updatedRows = [...rows];
        updatedRows[index] = { ...updatedRows[index] };
        updatedRows[index][field] = value;

        if (field === 'tipo') {
            const tipoSeleccionado = options.tipos.find((t) => t.nombre === value);
            updatedRows[index].subtipo = '';
            updatedRows[index].cantidad = '';
            updatedRows[index].unidad = '';
        }

        if (field === 'subtipo') {
            const tipoSeleccionado = options.tipos.find((t) => t.nombre === updatedRows[index].tipo);
            if (tipoSeleccionado) {
                const subtipoSeleccionado = tipoSeleccionado.subtipos.find((s) => s.nombre === value);
                if (subtipoSeleccionado) {
                    updatedRows[index].unidad = value === 'Otro' ? '' : subtipoSeleccionado.unidad;
                }
            }
        }

        if (field === 'unidad') {
            updatedRows[index].unidad = value;
        }

        setRows(updatedRows);
        loadField('formA', 'tipoSubtipoProyecto', null, updatedRows);
    };
    
    /*
    const handleChange = (index, field, value) => {
        const newRows = [...rows];
        newRows[index] = { ...newRows[index], [field]: value };

        // Si cambia el tipo, reiniciar el subtipo
        if (field === 'tipo') {
            newRows[index].subtipo = '';
            newRows[index].otroSubtipo = '';
        }

        setRows(newRows);
    };
    */

    //*****states******
    //NOTA 26JUL2025: para la carga inicial si recibe desde formA un arrayTipoSubtipoProyecto y es un array
    // y tiene datos usarlo para cargar los rows
    //NOTA 2: no se vuelve un bucle infinito porque los cambios en el Subformulario no impactan en 'registro, sino en 'rows'
    //cambian dataSubformulario en el padre
    //ANTES
    /*
    useEffect(()=>{
        if(Array.isArray(arrayTipoSubtipoProyecto) && arrayTipoSubtipoProyecto.length > 0){
            console.log("OSO cargar datos desde arrayTipoSubtipoProyecto")
            setRows(arrayTipoSubtipoProyecto) // FUNDAMENTAL
        }
    }, [arrayTipoSubtipoProyecto]) //arrayTipoSubtipoProyecto

    useEffect(()=>{
        onDataChangeSub(rows) //25JUL2025: cada vez que cambie rows ejecutar onDataChangeSub
    }, [rows])
    */    

    // Determinar si mostrar el campo "Otro" para un subtipo
    const isSubtipoOtros = (subtipo) => subtipo === 'Otro';

    return (
        <div className="p-4">
            {rows.map((row, index) => {
                const tipoSeleccionado = options.tipos.find((t) => t.nombre === row.tipo);

                const subtipos = tipoSeleccionado ? tipoSeleccionado.subtipos : [];

                // Determinar si el Subtipo actual es "Otro"
                const isSubtipoOtros = row.subtipo === 'Otro'; //cambio 23-mar-25: originalmente era Otro, mantener por si vuelve seleccion de la unidad

                return (
                    <div key={index} className="mb-4 border rounded-lg p-4 bg-white dark:bg-gray-800 shadow-sm">
                        <div className="flex justify-between items-center mb-2">
                        <h4 className="font-medium">Tipo de Proyecto {index + 1}</h4>
                        {rows.length > 0 && (
                            <div className="flex justify-end mt-2">
                                <Button 
                                    variant={rows.length <= 1 ? "ghost" : "destructive"}
                                    size="sm"
                                    onClick={() => removeRow(index)} //onClick={() => handleRemoveRow(index)}
                                    className={`px-2 py-1 text-xs ${rows.length <= 1 ? "text-gray-400 cursor-not-allowed" : ""}`}
                                    disabled={rows.length <= 1}
                                >
                                    Eliminar
                                </Button>
                            </div>
                        )}
                        </div>

                        <div className="grid grid-cols-2 gap-4 mb-4">
                            <div>
                                <Label htmlFor={`tipo_${index}`}>Tipo</Label>
                                <div className="mt-1">
                                    <Select_simple
                                        id={`tipo_${index}`}
                                        options={[
                                            { value: '', label: 'Seleccionar Tipo' }, // Opción por defecto
                                            ...options.tipos.map(t => ({ value: t.nombre, label: t.nombre }))
                                        ]}
                                        value={row.tipo || ''}
                                        onChange={(e) => handleChange(index, 'tipo', e.target.value)}
                                    />
                                </div>
                            </div>
                            
                            <div>
                                <Label htmlFor={`subtipo_${index}`}>Subtipo</Label>
                                <div className="mt-1">
                                    <Select_simple
                                        id={`subtipo_${index}`}
                                        options={[
                                            { value: '', label: 'Seleccionar Subtipo' }, // Opción por defecto
                                            ...subtipos.map(s => ({ value: s.nombre, label: s.nombre }))
                                        ]}
                                        value={row.subtipo || ''}
                                        onChange={(e) => handleChange(index, 'subtipo', e.target.value)}
                                        isDisabled={!row.tipo}
                                    />
                                </div>
                            </div>
                        </div>
                        
                        <div className="grid grid-cols-2 gap-4">
                            <div>
                                <Label htmlFor={`cantidad_${index}`}>Cantidad</Label>
                                <div className="mt-1">
                                    <Input
                                        id={`cantidad_${index}`}
                                        type="number" 
                                        placeholder="Cantidad"
                                        value={row.cantidad || ''}
                                        onChange={(e) => handleChange(index, 'cantidad', e.target.value)}
                                        disabled={!row.subtipo} 
                                    />
                                </div>
                            </div>

                            <div>
                                <Label htmlFor={`unidad_${index}`}>Unidad</Label>
                                <div className="mt-1">
                                    <Input
                                        id={`unidad_${index}`}
                                        type="text"
                                        placeholder="Unidad"
                                        value={row.unidad || ''}
                                        readOnly
                                        disabled={!row.subtipo}
                                        className="bg-gray-100 dark:bg-gray-700 cursor-not-allowed"
                                    />
                                </div>
                            </div>
                        </div>

                        
                    </div>
                );
            })}

            <div className="flex justify-end mt-4">
                <Button
                    onClick={addRow} //{handleAddRow}
                    variant="default" // O la variante que uses para botones primarios
                    className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                >
                    Agregar nuevo Tipo y Subtipo
                </Button>
            </div>
        </div>
    );
};

export default memo(TipoProyectoSubform);

//cambiar process.env.NODE_ENV === 'development' && ---> por user === 'Javier' &&